import { CobranzasAxios, COMPANY } from './config'

export const getCompaniesNapCobranzas = async () => {
  const res = await CobranzasAxios.get(`/client/${COMPANY}`)
  return res.data
}

export const postClients = async (data) => {
  const res = await CobranzasAxios.post(`/client/${COMPANY}`, data)
  return res.data
}

export const putClients = async (data, id) => {
  const res = await CobranzasAxios.put(`/client/${id}`, data)
  return res.data
}

export const importClients = async (data) => {
  const res = await CobranzasAxios.post(`/client/import/${COMPANY}`, data)
  return res.data
}
